import doisotrung from "../../assets/images/doisotrung.gif";
import veso from "../../assets/images/icons/veso.gif";
import printGif from "../../assets/images/icons/print.gif";
import React from "react";

const LinkBotton = () => {
    return (
        <>
            <div className="bangkqxs_link">
                <table cellSpacing="4">
                    <tbody>
                    <tr>
                        <td nowrap="nowrap" valign="middle">
                            <a href="/" className="bottom-link">
                                <img alt="dd"
                                     className="me-link"
                                     src={doisotrung}
                                /> Đổi số trúng</a>
                        </td>
                        <td nowrap="nowrap"><a href="/" className="bottom-link"
                                               title="Mẫu vé kiểm tra khi đổi số trúng thưởng">
                            <img className="me-link" alt="" src={veso}/>Mẫu
                            vé kiểm tra</a></td>
                        <td nowrap="nowrap"><a href="/" className="bottom-link"
                                               title="In vé dò (in bảng kết quả xổ số) Miền Trung ngày 08/06/2021">
                            <img className="me-link" alt="" src={printGif}/>In
                            Vé Dò</a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};
export default LinkBotton;
